module.exports = __webpack_public_path__ + "img/bb-trash2-icon.ba36fdc3.svg";